import React from 'react'

import Button from '@mui/material/Button'

const CreateJoinUrlButton = props => {
  const { onClickJoinRoom, disabled, loading, variant, size, color } = props

  return (
    <Button
      disabled={disabled}
      onClick={onClickJoinRoom}
      variant={variant}
      size={size}
      color={color}
    >
      {loading ? 'Wait…' : 'Join Room'}
    </Button>
  )
}

export default CreateJoinUrlButton
